<div class="sidebar-panel app-sidebar-shell" [class.context-collapsed]="!showContextPanel">
    <div class="desktop-sidebar-view">
        <div id="scroll-area" [perfectScrollbar] class="navigation-hold flex flex-col">
            <div class="sidebar-hold">
                <app-sidenav [items]="menuItems" [hasIconMenu]="false"></app-sidenav>
            </div>
        </div>
    </div>

    <div class="mobile-sidebar-view">
        <nav class="sidebar-icon-rail" aria-label="Primary navigation">
            <a *ngFor="let item of primaryMenuItems"
                [routerLink]="'/' + item.state"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: false}"
                [matTooltip]="item.name"
                matTooltipPosition="right"
                [attr.aria-label]="item.name">
                <mat-icon *ngIf="item.icon">{{item.icon}}</mat-icon>
                <mat-icon *ngIf="item.svgIcon" [svgIcon]="item.svgIcon"></mat-icon>
            </a>
        </nav>

        <section class="sidebar-context-panel" aria-label="Section navigation" *ngIf="showContextPanel">
            <div class="sidebar-context-header">
                <mat-icon>arrow_back</mat-icon>
                <span>{{activeMenuItem?.name | translate}}</span>
            </div>

            <div id="mobile-scroll-area" class="sidebar-navigation">
                <app-sidenav [items]="menuItems" [hasIconMenu]="false"></app-sidenav>
            </div>
        </section>
    </div>
</div>
